import React, { Component } from 'react';
import Field from 'redux-form/lib/Field';
import reduxForm from 'redux-form/lib/reduxForm';
import Alert from 'react-bootstrap/lib/Alert';
import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import FieldFormGroup from '../FieldFormGroup';
import Footer from '../Footer';
import OutboundLink from '../OutboundLink';
import styles from './styles.sass';

function ResetPassword({
  error,
  errors,
  handleSubmit,
  submitting,
  resetTokenIsValid,
  resetWasSuccessful,
}) {
  return (
    <div className={`${styles.resetPassword} isV2LegacyPage`}>
      <Grid>
        <Row>
          <Col lg={4} lgOffset={4} md={6} mdOffset={3}>
            {!resetTokenIsValid && (
              <p className="text-center">
                Sorry, but that reset password link is no longer valid.
              </p>
            )}
            {resetWasSuccessful && (
              <Alert bsStyle="success" className="text-center">
                <p>Your password has been saved!</p>
                <p>You can now log in with it.</p>
              </Alert>
            )}
            {resetTokenIsValid &&
              !resetWasSuccessful && (
                <form onSubmit={handleSubmit} id="form1">
                  {error && <Alert bsStyle="danger">{error}</Alert>}
                  <div>
                    <Field
                      name="password"
                      placeholder="Password"
                      component={FieldFormGroup}
                      type="password"
                      showFieldLevelError
                    />
                    <Field
                      name="repeatPassword"
                      placeholder="Type it again"
                      component={FieldFormGroup}
                      type="password"
                      showFieldLevelError
                    />
                  </div>
                  <FormGroup>
                    <Button
                      bsStyle="primary"
                      block
                      type="submit"
                      disabled={submitting}
                      bsSize="large"
                    >
                      Reset Password
                    </Button>
                  </FormGroup>
                </form>
              )}
          </Col>
        </Row>
      </Grid>
      <Footer />
    </div>
  );
}

export default reduxForm({
  form: 'resetPassword',
  validate,
})(ResetPassword);

function validate(values) {
  const errors = {};
  if (!values.password || values.password.length < 7) {
    errors.password = 'Passwords must be 7 characters or more';
  }
  if (values.password !== values.repeatPassword) {
    errors.repeatPassword = 'The passwords do not match';
  }
  return errors;
}
